<template>
  <div class="wrap">
    <div class="list">
      <div class="emptyBox colAc" v-if="list.length == 0">
        <img src="../../assets/static/emptyList.png" alt="" />
        <div>暂时还没有管辖机构哦</div>
      </div>
      <div
        class="listitem"
        v-for="(item, index) in list"
        :key="index"
        @click="goCampusList(item.institutionCode)"
      >
        <div class="organization_campus textOver">
          {{ item.institutionName }}
        </div>
        <div class="itemLine">
          总共<span class="spec">{{ item.campusCount }}</span
          >家校区
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getManageInstitutionAPI } from "../../utils/api/api";

export default {
  data() {
    return {
      publicAccountType: "",
      openid: "",
      list: [],
    };
  },
  created() {
    // this.publicAccountType = window.localStorage.getItem("publicAccountType");
    // this.openid = window.localStorage.getItem("openid");
    this.publicAccountType = this.$common.getCache('publicAccountType')
    this.openid = this.$common.getCache('openid')
    this.getManageInstitution();
  },
  methods: {
    goCampusList(institutionCode) {
      this.$router.push({
        path: "/campusList",
        query: { institutionCode: institutionCode },
      });
    },
    //获取管辖机构列表
    getManageInstitution() {
      var obj = {
        openid: this.openid,
        innerAppId: this.publicAccountType,
      };
      console.log("管辖机构obj", obj);
      getManageInstitutionAPI(obj).then((res) => {
        if (res.resultCode == 200) {
          console.log("获取列表成功", res.data);
          this.list = res.data;
        } else {
          console.log(res.resultStr);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: 100%;
  background: #f4faff;
  padding: 0px 0 0 0.15rem;
  box-sizing: border-box;
  overflow: auto;
}
.list {
  padding-right: 0.15rem;
  flex: 1;
  overflow: auto;
  box-sizing: border-box;
}
.listitem {
  margin-top: 28px;
  background: linear-gradient(180deg, #d8f1ff 0%, #ffffff 20%);
  box-shadow: 4px 4px 11px 0px rgba(229, 236, 243, 0.8),
    -9px -9px 22px 0px rgba(255, 255, 255, 0.5);
  border-radius: 17px;
  padding: 20px 0px 24px 20px;
  height: 103px;
  box-sizing: border-box;
}
.organization_campus {
  font-size: 17px;
  font-weight: 500;
  color: #333843;
  line-height: 24px;
  margin-bottom: 12px;
}
.itemLine {
  color: #333843;
  font-size: 16px;
  line-height: 23px;
}
.spec {
  color: #6985ff;
  margin: 0 2px;
}
</style>